import { ref } from "vue";
import { defineStore, storeToRefs } from "pinia";
import { editChannel, syncChannel } from "@/lib/broadcast-channels";

export const useEditStore = defineStore("edit", () => {
    const canEdit = ref(true);
    const isEditing = ref(false);

    const startEditing = async () => {
        if (canEdit.value) {
            isEditing.value = true;
            editChannel.postMessage("start");
        }
    };
    const stopEditing = () => {
        isEditing.value = false;
    };

    editChannel.addEventListener("message", (event) => {
        if (event.data === "start") {
            stopEditing();
        }
    });

    syncChannel.addEventListener("message", ({ data: { message } }) => {
        if (message === "queued") {
            canEdit.value = false;
        } else if (message === "synced") {
            canEdit.value = true;
        }
    });

    return { canEdit, isEditing, startEditing, stopEditing };
});

export const useEditManager = () => storeToRefs(useEditStore());
